import React from "react";
import "./sidebar-title.css";

export function SidebarTitle({ children }: { children: React.ReactNode }) {
	return <div className="sidebar-title">{children}</div>;
}
